import { ServerSideBlotterSearchRequest } from 'apiConnector/blotters';

import './quotes-blotter.scss';
import classnames from 'classnames';
import { ConnectedQuoteBlotterFilter } from 'components/Blotters/Quotes/Filter/Filter';
import { QuotesBlotterServerSideGrid } from 'components/Blotters/Quotes/Grid/quote-blotter-serverside';
import { BlotterPanel } from 'components/shared/Blotter/BlotterPanel/BlotterPanel.connect';
import { useAppSelector } from 'hooks/useAppSelector';
import { FC, useState } from 'react';
import { isBlotterPanelItemActive } from 'state/blotters/blotterPanel/blotterPanel.selector';

export const QuotesBlotter: FC = () => {
  const [lastBlotterRequest, setLastBlotterRequest] = useState<ServerSideBlotterSearchRequest>();

  const isBlotterPanelActive = useAppSelector(isBlotterPanelItemActive);

  return (
    <div className="container-fluid px-0 h-100 gap-4" data-e2e="quotes-blotter-container">
      <div className="d-flex flex-column h-100">
        <div className="d-flex flex-row bg-lvl1 flex-wrap">
          <ConnectedQuoteBlotterFilter lastBlotterRequest={lastBlotterRequest} />
        </div>
        <div className="d-flex flex-row flex-grow-1 min-h-0 vh-100">
          <div
            className={classnames(
              'd-flex flex-column p-0',
              isBlotterPanelActive ? 'col-md-6 col-lg-8 col-xl-9 col-xxl-9' : 'col-12',
            )}
          >
            <QuotesBlotterServerSideGrid setLastBlotterRequest={setLastBlotterRequest} />
          </div>
          {isBlotterPanelActive && (
            <div className="col-md-6 col-lg-4 col-xl-3 col-xxl-3 px-0">
              <BlotterPanel />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
